import {
  RESET_PARTNER_MESSAGE,
  GET_PARTNER,
  GET_PARTNER_SUCCESS,
  GET_PARTNER_FAIL,
  UPDATE_PARTNER,
  UPDATE_PARTNER_SUCCESS,
  UPDATE_PARTNER_FAIL,
  ADD_PARTNER_SUCCESS,
  ADD_PARTNER_FAIL,
  ENROLE_PATIENT_SHARE,
  ENROLE_PATIENT_SHARE_SUCCESS,
  ENROLE_PATIENT_SHARE_ERROR,
} from "./actionTypes";

const initialState = {
  facilities: [],
  loadingFacilities: false,
  loadingUpdate: false,
  success: {
    message: "",
  },
  error: {
    message: "",
  },
};

const PartnerReducer = (state = initialState, action) => {
  switch (action.type) {
    case RESET_PARTNER_MESSAGE:
      state = {
        ...state,
        success: {
          message: "",
        },
        error: {
          message: "",
        },
      };
      break;
    case GET_PARTNER:
      state = { ...state, loadingPartner: true };
      break;
    case GET_PARTNER_SUCCESS:
      state = {
        ...state,
        partners: action.payload,
        loadingPartner: false,
      };
      break;
    case GET_PARTNER_FAIL:
      state = {
        ...state,
        error: action.payload,
        loadingPartner: false,
      };
      break;
    case UPDATE_PARTNER:
      state = { ...state, loadingUpdate: true };
      break;
    case UPDATE_PARTNER_SUCCESS:
      state = { ...state, success: action.payload || [], loadingUpdate: false };
      break;
    case UPDATE_PARTNER_FAIL:
      state = {
        ...state,
        error: action.payload,
        loadingUpdate: false,
      };
      break;
    case ADD_PARTNER_SUCCESS:
      state = { ...state, success: action.payload || [] };
      break;
    case ADD_PARTNER_FAIL:
      state = {
        ...state,
        error: action.payload,
      };
      break;
    case ENROLE_PATIENT_SHARE:
      console.log('ENROLE_PATIENT_SHARE');
      state = { ...state, enroling: true };
      break;

    case ENROLE_PATIENT_SHARE_SUCCESS:
      console.log('ENROLE_PATIENT_SHARE_SUCCESS', action.payload);
      state = { ...state, success: action.payload || [] };
      break;
    case ENROLE_PATIENT_SHARE_ERROR:
      console.log('ENROLE_PATIENT_SHARE_ERROR');
      state = {
        ...state,
        error: action.payload,
        enroling: false
      };
      break;

    default:
      state = { ...state };
      break;
  }
  return state;
};

export default PartnerReducer;
